import React from 'react';
import {Paper} from 'material-ui';
import Collapsible from 'react-collapsible';

class CollapsiblePaper extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      expand: props.expand
    }
  }

  onExpand = () => this.setState({expand: !this.state.expand});

  render() {
    let {
      title,
      children,
      containerHeight,
      contentHeight,
      style
    } = this.props;

    return (
      <div>
        <Paper zDepth={1} style={{...style, maxHeight: containerHeight}}>
          <Collapsible open={this.state.expand} style={style} triggerClassName="myTableHead" handleTriggerClick={this.onExpand} triggerOpenedClassName="myTableHead" trigger={
            <div onClick={this.onExpand}>
              {title}
              <span className={`glyphicon ${this.state.expand? "glyphicon-chevron-up" : "glyphicon-chevron-down"} pull-right`}/>
            </div>
          }>
            <div style={{maxHeight: contentHeight, padding: '5px', overflowY: 'scroll', color: '#0f72a9'}}>
              {children}
            </div>
          </Collapsible>

        </Paper>
      </div>
    );
  }
}

export default CollapsiblePaper;


// WEBPACK FOOTER //
// ./src/components/common/CollapsiblePaper.js